import * as tslib_1 from "tslib";
import * as React from "react";
import { API_URL, LOGOUT_LINK } from "../config/urls";
import axios from "axios";
import { updateAuthToken } from "../actions/app";
import { connect } from "react-redux";
var Header = /** @class */ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            users: 0,
            experts: 0,
            approved: 0,
            declined: 0,
        };
        return _this;
    }
    Header.prototype.componentWillMount = function () {
        var _this = this;
        axios.get(API_URL + "/stat").then(function (r) {
            if (r.data && r.data.code && r.data.code === 200) {
                _this.setState(tslib_1.__assign({}, r.data.data));
            }
        }).catch(function (e) { return console.log(e); });
    };
    Header.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("header", { id: "m_header", className: "m-grid__item    m-header ", "m-minimize-offset": "200", "m-minimize-mobile-offset": "200" },
                React.createElement("div", { className: "m-container m-container--fluid m-container--full-height" },
                    React.createElement("div", { className: "m-stack m-stack--ver m-stack--desktop" },
                        React.createElement("div", { className: "m-stack__item m-stack__item--fluid m-header-head dv_style", id: "m_header_nav" },
                            React.createElement("div", { className: "dv_style_flag" }),
                            React.createElement("div", { className: "dv_style_logo" }),
                            React.createElement("div", { className: "dv_style_text" }, "\u041C\u0438\u043D\u0438\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u043E \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044E \u0414\u0430\u043B\u044C\u043D\u0435\u0433\u043E \u0412\u043E\u0441\u0442\u043E\u043A\u0430"),
                            React.createElement("div", { className: "dv_style_stat" },
                                "\u041A\u043E\u043B-\u0432\u043E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 - ",
                                this.state.users,
                                " / \u042D\u043A\u0441\u043F\u0435\u0440\u0442\u043E\u0432 - ",
                                this.state.experts,
                                " / \u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u043E - ",
                                this.state.approved,
                                " / \u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E - ",
                                this.state.declined),
                            React.createElement("div", { onClick: function () {
                                    var at = localStorage.getItem('authToken');
                                    localStorage.removeItem("authToken");
                                    _this.props.dispatch(updateAuthToken(""));
                                    window.location.href = (LOGOUT_LINK + '?token=' + at + '&redirect_uri=' + window.location.origin);
                                }, className: "dv_style_logout" }, "\u0412\u044B\u0439\u0442\u0438")))))));
    };
    return Header;
}(React.Component));
export default connect(function (state) { return ({
    isAdmin: state.app.get("is_sadmin"),
}); })(Header);



//////////////////
// WEBPACK FOOTER
// ./src/components/Header.tsx
// module id = 293
// module chunks = 0